import axios from "axios";
// config

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_APP_BASE_URL,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: `Token ${localStorage.getItem("Token")}`,
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
